export const shouldShowSubscribeButton = (
  isLoggedIn: boolean | null,
  hasAccess: boolean | null,
  isPaused: boolean | null,
) => {
  if (isLoggedIn === null || hasAccess === null || isPaused === null) {
    return false;
  }
  if (hasAccess || isPaused) {
    return false;
  }
  return true;
};
